import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const projectStatus = [
  {
    name: "Manufacturing",
    count: 6,
    color: "#a855f7",
    icon: (
      <PrecisionManufacturingIcon fontSize="small" sx={{ color: "#a855f7" }} />
    ),
  },
  {
    name: "PDI Request",
    count: 2,
    color: "#f43f5e",
    icon: <InventoryIcon fontSize="small" sx={{ color: "#f43f5e" }} />,
  },
  {
    name: "Dispatch",
    count: 4,
    color: "#fb923c",
    icon: <LocalShippingIcon fontSize="small" sx={{ color: "#fb923c" }} />,
  },
  {
    name: "Delivered",
    count: 4,
    color: "#22c55e",
    icon: <TaskAltIcon fontSize="small" sx={{ color: "#22c55e" }} />,
  },
];

const OngoingProjectStatus = () => {
  const totalLots = projectStatus.reduce((acc, curr) => acc + curr.count, 0);

  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 5,
        boxShadow: 6,
        p: 2,
        width: "100%", // takes full width of parent
        minHeight: "100%",
        margin: "auto",
      }}
    >
      <Box
        mx={2}
        py={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        borderBottom={1}
        borderColor="divider"
      >
        <Typography variant="h5" fontWeight={700}>
          Ongoing Project status
        </Typography>
      </Box>

      <CardContent>
        {/* Total Lots */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h4" fontWeight="bold">
            {totalLots}{" "}
            <Typography
              component="span"
              variant="body2"
              color="text.secondary"
              fontWeight={500}
            >
              Lots
            </Typography>
          </Typography>

          {/* Color bar segments */}
          <Box
            sx={{
              display: "flex",
              height: 8,
              borderRadius: 4,
              overflow: "hidden",
              mt: 1,
            }}
          >
            {projectStatus.map((item, idx) => {
              const width = `${(item.count / totalLots) * 100}%`;
              return (
                <Box
                  key={idx}
                  sx={{
                    width,
                    backgroundColor: item.color,
                    transition: "width 0.3s ease-in-out",
                    marginRight: 0.5,
                    borderRadius: 5,
                  }}
                />
              );
            })}
          </Box>
        </Box>

        {/* Status List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {projectStatus.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#F6F8FA",
                p: 1,
                borderRadius: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {item.icon}
                <Typography
                  fontSize={16}
                  fontWeight={500}
                  sx={{ color: "black" }}
                >
                  {item.name}
                </Typography>
              </Box>
              <Typography variant="body2" fontWeight="bold">
                {item.count}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default OngoingProjectStatus;
